import axios from "axios";
import authHeader from "./auth-header";
import store from "../store";
import { useSelector } from "react-redux";

const toTimestamp = (strDate) => {
    if (strDate !== "" && strDate !== null && strDate !== undefined) {
        const dt = Date.parse(strDate);
        return dt / 1000;
    } else {
        return 0;
    }
}
var dateNow = new Date()
var expireDate = localStorage.getItem('date');
if (expireDate !== undefined && expireDate !== null && isNaN(toTimestamp(expireDate)) === false && toTimestamp(dateNow) >= toTimestamp(expireDate)) {
    localStorage.setItem('expireDate', true);
}
// const API_URL = "https://ipoppms-mockup-api.soda.in.th/api/";
const API_URL_FETCH = localStorage.getItem("API_URL")
const FIRST_API = process.env.REACT_APP_API_URL;
const API_URL = API_URL_FETCH || FIRST_API;

axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    store.dispatch({
        type: "ADD_LOADER"
    })
    return config;
}, function (error) {
    store.dispatch({
        type: "MINUS_LOADER"
    })
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    store.dispatch({
        type: "MINUS_LOADER"
    })
    if (response.data?.token) {
        localStorage.setItem("token", response.data.token);
    }
    if (response.data?.expire) {
        localStorage.setItem("date", response.data.expire);
    }
    store.dispatch({
        type: "ERROR",
        payload: null,
    })


    if (response.data?.statuscode?.code === '401' || response.data?.statuscode?.code === 401) {
        localStorage.setItem('expireDate', true);
        store.dispatch({
            type: "ERROR",
            payload: { error: response?.data?.statuscode?.code, message: response?.data?.message },
        })
    }


    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    store.dispatch({
        type: "MINUS_LOADER"
    })
    if (error?.response?.data?.statuscode?.code === "401" || error?.response?.data?.statuscode?.code === 401) {
        localStorage.setItem('expireDate', true);
        store.dispatch({
            type: "ERROR",
            payload: { error: error?.response?.data?.statuscode?.code, message: error?.response?.data?.message },
        })
        return Promise.reject(error);
    } else if (error?.response?.status === "500" || error?.response?.status === 500 || error?.response?.status === "401" || error?.response?.status === 401 || error?.response?.status === "403" || error?.response?.status === 403) {
        // console.log({ error: error?.response });
        store.dispatch({
            type: "ERROR",
            payload: { error: error?.response?.status, message: error?.response?.data?.message },
        })
        return Promise.reject(error);
    } else {
        return Promise.reject(error);
    }
});

class RestService {
    get(vURL, headers = authHeader()) {
        return new Promise((fnResolve, fnReject) => {
            const IS_EXTERNAL = vURL.indexOf('https://') !== -1

            let url = vURL.indexOf('site') >= 0 ? FIRST_API + vURL : API_URL + vURL

            if (IS_EXTERNAL) url = vURL

            axios.get(url, { headers: headers })
                .then((response) => {
                    if (response.data.success) {
                        if (vURL.indexOf('site') >= 0) {
                            localStorage.removeItem("API_URL")
                        }

                        if (response.data.data?.configuration?.api_url) {
                            localStorage.setItem("API_URL", response.data.data.configuration.api_url)
                        }

                        fnResolve(response)
                        return;
                    } else if (IS_EXTERNAL) {

                        console.log(response)


                        fnResolve(response)
                    }


                    fnReject(response)
                }).catch(function (error) {
                    fnReject(error)
                })
        })
    }
    post(vURL, data, headers = authHeader()) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: headers })
                .then((response) => {
                    if (response.data.success) {
                        fnResolve(response)
                    }
                    fnReject(response)
                }
                )
                .catch(function (error) {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        fnReject(error.response)
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                });

        })
    }

    patch(vURL, data, headers = authHeader()) {
        return new Promise((fnResolve, fnReject) => {
            axios.patch(API_URL + vURL, data, { headers: headers })
                .then((response) => {
                    if (response.data.success) {
                        fnResolve(response)
                    }
                    fnReject(response)
                }).catch(function (error) {
                    fnReject(error)
                })
        })
    }

    delete(vURL, headers = authHeader()) {
        return new Promise((fnResolve, fnReject) => {
            axios.delete(API_URL + vURL, { headers: headers })
                .then((response) => {
                    if (response.data.success) {
                        fnResolve(response)
                    }
                    fnReject(response)
                }).catch(function (error) {
                    fnReject(error)
                })
        })
    }

    getConsent(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    // localStorage.setItem("date", response.expire);
                    if (response.data.success) {
                        fnResolve(response)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    postConsent(vURL, data) {
        return new Promise((fnResolve, fnReject) => {

            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response)
                        return;
                    }
                    fnReject(response)
                }
                )
                .catch(function (error) {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx

                        fnReject(error.response.data)

                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                });

        })
    }

    createEvaluatiions(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response)
                        return;
                    }
                    fnReject(response)
                }
                )
                .catch(function (error) {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx

                        fnReject(error.response.data)

                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                });

        })
    }

    getCategorys(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getCompetency(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getFormWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getYearWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getDetailWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data.data)
                        return;
                    }
                    fnReject(response)
                })
                .catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }
                    fnReject(null)
                })
        })
    }

    getTypeWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getListWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getSummaryWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    uploadFilesWorkloadAndPerformance(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getFilesWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    deleteFilesWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.delete(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    openFilesWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    posts(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }
                    fnReject(null)
                })
        })
    }

    postsReset(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }
                    fnReject(error.response)
                })
        })
    }

    put(vURL, data = {}) {
        return new Promise((fnResolve, fnReject) => {
            axios.put(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }
                    fnReject(null)
                })
        })
    }
    puts(vURL, data = {}) {
        return new Promise((fnResolve, fnReject) => {
            axios.put(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }
                    fnReject(error.response)
                })
        })
    }

    getConfigs(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }
                    fnReject(null)
                })
        })
    }

    deleteListsWorkloadAndPerformance(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.delete(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }
                    fnReject(null)
                })
        })
    }

    getplanning(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                        fnReject(error.response)
                        return;
                    }
                    fnReject(null)
                })
        })
    }

    getmainPlanning(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        fnReject(error.response)
                        return;
                    }
                    fnReject(null)
                })
        })
    }

    carryScore(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getHome(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    sendApprove(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getProfile(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        fnReject(error.response)
                        return;
                    }
                    fnReject(null)
                })
        })
    }

    uploadFilesProfile(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getDetailCompetency(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }
    getMyGoal(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getNews(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }

    getContentNews(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {

                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }

    getTags(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getTagsList(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }

    getHandbooks(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }

    getContentHandBook(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {

                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }

    getFaqs(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }


    getFaqType(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }

    addFaq(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        // localStorage.setItem("error", error?.response?.data?.statuscode?.code);
                    }

                })
        })
    }

    getSupportType(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })

    }

    addMyGoal(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        fnReject(null)
                    }

                })
        })
    }

    editMyGoal(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.put(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) {
                        fnReject(null)
                    }

                })
        })
    }

    getListJobData(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getListEvaluateType(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    gets(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getListCycle(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getDetailJobData(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getListPosition(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getDetailPosition(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getCurrentEmployees(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    deleteMyGoal(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.delete(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    putDeleteMyGoal(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.put(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }

    getGoalForEdit(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.get(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }
    postSubmitApproval(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.post(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }
    putUpdateProgress(vURL, data) {
        return new Promise((fnResolve, fnReject) => {
            axios.put(API_URL + vURL, data, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }
    deleteProgressHistory(vURL) {
        return new Promise((fnResolve, fnReject) => {
            axios.delete(API_URL + vURL, { headers: authHeader() })
                .then((response) => {
                    localStorage.setItem("date", response.data.expire);
                    if (response.data.success) {
                        fnResolve(response.data)
                        return;
                    }
                    fnReject(response)
                }).catch(function (error) {
                    if (error.response) { }
                    fnReject(null)
                })
        })
    }
}



export default new RestService();
